// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"b93c46c1","82":"6df8b3c7","203":"e91bf5e1","219":"88e612d1","319":"d1541189","715":"ce482a07","864":"02d00141","874":"f69f3df4"}[chunkId] + ".chunk.css";
};